import React from 'react';
import { appStore } from 'src/mobx/appStore';
import { cartStore } from 'src/mobx/cartStore';
import { IProduct, IProductExclusion, IProductModifier } from 'src/types/products';
import Exclusions from 'src/view/components/Controls/Exclusions/Exclusions';
import Notes from 'src/view/components/Controls/Notes/Notes';
import ProductModifier from '../../components/ProductModifier/ProductModifier';
import ProductNotes from '../../components/ProductNotes/ProdutcNotes';

interface IProps {
  product?: IProduct;
  errors: number[];
  needScrollToError: boolean;
  onModifierChange: (modifier: IProductModifier) => void;
  setNeedScrollToError: (need: boolean) => void;
  onExclusionsChange: (exclusions: IProductExclusion[]) => void;
  onNotesChanged: (notes: string) => void;
  readonly?: boolean;
}

export default class ProductSelectorsBlock extends React.Component<IProps, {}> {
  render() {
    const { product, readonly } = this.props;

    const showNotes =
      appStore.settings?.item_notes && (!cartStore.isSMS || (cartStore.isEditable && product?.hash) || product?.notes);

    return (
      <div className="product-block d-flex flex-column product-submit-block product-block-padding">
        {product?.modifiers.length || product?.exclusions.length ? (
          <div className="product-selectors hide-scrollbar">
            <div className="product-scroll">
              {/* Modifiers */}
              {product.modifiers.map((modifier) => (
                <div id={`modifier_${modifier.id}`} key={modifier.id} className="mb-4">
                  <ProductModifier
                    modifier={modifier}
                    errors={this.props.errors}
                    needScrollToError={this.props.needScrollToError}
                    onModifierChange={this.props.onModifierChange}
                    setNeedScrollToError={this.props.setNeedScrollToError}
                    readOnly={readonly}
                  />
                </div>
              ))}
              {/* Exclusions */}
              {Array.isArray(product.exclusions) && product.exclusions.length ? (
                <Exclusions
                  exclusions={product.exclusions}
                  className="mb-4"
                  onChange={this.props.onExclusionsChange}
                  readOnly={!cartStore.isEditable || (cartStore.isSMS && !product.hash)}
                />
              ) : null}
            </div>
          </div>
        ) : null}
        {showNotes ? (
          <ProductNotes
            loading={!product}
            onChange={this.props.onNotesChanged}
            value={product?.notes || ''}
            disabled={!cartStore.isEditable}
          />
        ) : null}
      </div>
    );
  }
}
